import React, { useEffect, useState } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { isAuthenticated, logoutUser, getUserId } from '../utils/auth';
import apiClient from '../api/apiClient';
import '../styles/navbar.css';

const Navbar = () => {
  const [userData, setUserData] = useState(null);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        if (isAuthenticated()) {
          const userId = getUserId();
          const response = await apiClient.get(`/api/users/v1/${userId}`);
          setUserData(response.data.data);
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    };
    fetchUserData();
  }, []);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleLogout = () => {
    logoutUser();
    navigate('/login');
  };

  const closeMobile = () => setMobileOpen(false);

  return (
    <>
      <nav className={`nav ${scrolled ? 'nav--scrolled' : ''}`}>
        <div className="nav__inner">
          <Link to={isAuthenticated() ? '/dashboard' : '/'} className="nav__brand" onClick={closeMobile}>
            <span className="nav__brand-mark">ORN</span>
            <span className="nav__brand-text">Online Record News</span>
          </Link>

          <button
            className={`nav__hamburger ${mobileOpen ? 'nav__hamburger--open' : ''}`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            <span /><span /><span />
          </button>

          <div className={`nav__links ${mobileOpen ? 'nav__links--open' : ''}`}>
            {isAuthenticated() ? (
              <>
                {userData && (
                  <span className="nav__user">
                    <span className="nav__user-avatar">
                      {userData.first_name?.charAt(0)?.toUpperCase() || '?'}
                    </span>
                    <span className="nav__user-name">{userData.first_name}</span>
                  </span>
                )}
                <NavLink to="/dashboard" className="nav__link" onClick={closeMobile}>
                  Dashboard
                </NavLink>
                <button onClick={() => { handleLogout(); closeMobile(); }} className="nav__btn nav__btn--logout">
                  Sign Out
                </button>
              </>
            ) : (
              <>
                <NavLink to="/" end className={({ isActive }) => `nav__link ${isActive ? 'nav__link--active' : ''}`} onClick={closeMobile}>
                  Home
                </NavLink>
                <NavLink to="/about" className={({ isActive }) => `nav__link ${isActive ? 'nav__link--active' : ''}`} onClick={closeMobile}>
                  About
                </NavLink>
                <NavLink to="/contact" className={({ isActive }) => `nav__link ${isActive ? 'nav__link--active' : ''}`} onClick={closeMobile}>
                  Contact
                </NavLink>
                <NavLink to="/login" className="nav__btn nav__btn--login" onClick={closeMobile}>
                  Sign In
                </NavLink>
              </>
            )}
          </div>
        </div>
      </nav>
      {/* Spacer */}
      <div className="nav__spacer" />
      {/* Mobile overlay */}
      {mobileOpen && <div className="nav__overlay" onClick={closeMobile} />}
    </>
  );
};

export default Navbar;
